import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Buttons from "../../../components/Buttons/Buttons";
import { PlusIcon } from "../../../assets/icons-components/Icons";

const SuperAdminSecondaryEmails = ({
  secondaryEmails,
  newSecondaryEmail,
  onNewSecondaryEmailChange,
  onAddSecondaryEmail,
  editingIndex,
  editingEmail,
  onEditingEmailChange,
  onEditSecondaryEmail,
  onSaveEditSecondaryEmail,
  onCancelEditSecondaryEmail,
  onDeleteSecondaryEmail,
}) => (
  <div className="secondary-emails-section">
    <h3>Secondary Emails</h3>
    <div className="secondary-emails-input-group">
      <input
        type="email"
        value={newSecondaryEmail}
        onChange={(e) => onNewSecondaryEmailChange(e.target.value)}
        placeholder="Enter secondary email"
        aria-label="Secondary email"
        className="secondary-email-input"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onAddSecondaryEmail();
          }
        }}
      />
      <Buttons
        text="Add"
        type="button"
        variant="smallprimary"
        onClick={onAddSecondaryEmail}
        icon={<PlusIcon />}
      />
    </div>

    {secondaryEmails.length > 0 && (
      <div className="secondary-emails-list">
        {secondaryEmails.map((email, index) => (
          <div key={email} className="secondary-email-item">
            {editingIndex === index ? (
              <>
                <input
                  type="email"
                  value={editingEmail}
                  onChange={(e) => onEditingEmailChange(e.target.value)}
                  aria-label="Edit secondary email"
                  className="secondary-email-edit-input"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      onSaveEditSecondaryEmail(index);
                    }
                  }}
                />
                <Buttons
                  className="save-edit-btn"
                  icon={<CheckIcon fontSize="small" />}
                  ariaLabel="Save email"
                  onClick={() => onSaveEditSecondaryEmail(index)}
                />
                <Buttons
                  className="cancel-edit-btn"
                  icon={<CloseIcon fontSize="small" />}
                  ariaLabel="Cancel edit"
                  onClick={onCancelEditSecondaryEmail}
                />
              </>
            ) : (
              <>
                <span>{email}</span>
                <Buttons
                  className="edit-email-btn"
                  icon={<EditIcon fontSize="small" />}
                  ariaLabel="Edit email"
                  onClick={() => onEditSecondaryEmail(index)}
                />
                <Buttons
                  className="delete-email-btn"
                  icon={<CloseIcon fontSize="small" />}
                  ariaLabel="Remove secondary email"
                  onClick={() => onDeleteSecondaryEmail(index)}
                />
              </>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);

export default SuperAdminSecondaryEmails;
